import { getErrorMessage } from "./errorHandler";
import authService from "../services/auth/index1";
import axiosApi from "axios";
import { isObject } from "lodash";
import {
  isNoAnswer,
  markServerDown,
  markServerUp,
} from "../services/offline/serverReach";

export const PERMISSION_ERR_MSG =
  "You don't have permission to perform this action. Please contact your organization admin.";

const axios = axiosApi.create({
  baseURL: process.env.REACT_APP_BASE_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

axios.interceptors.request.use((reqConfig) => {
  const token = localStorage.getItem("accessToken");
  if (token && !reqConfig.headers.Authorization) {
    reqConfig.headers.Authorization = `Bearer ${token}`;
  }

  return reqConfig;
});

axios.interceptors.response.use(
  async (response) => {
    markServerUp();
    const { data } = response;

    if (data && isObject(data))
      response.data = JSON.parse(JSON.stringify(data), (k, v) => {
        return ["created_at", "updated_at"].includes(k) &&
          typeof v === "string" &&
          !v.endsWith("Z")
          ? v + "Z"
          : v;
      });
    return response.data;
  },
  async (error) => {
    // no answer at all: the POS switches to saving orders on this device
    if (isNoAnswer(error)) markServerDown();
    else if (error.response) markServerUp();
    try {
      if (error.config?._ignoreError) throw error;

      let msg = getErrorMessage(
        error.response?.data?.error || error.response?.data,
        "",
      );
      if (!msg)
        msg = `${
          error.response?.statusText ? error.response.statusText + "! " : ""
        }${error.message}`;
      error.message = msg;

      if (
        error.response?.status === 401 &&
        !(
          error.config.url.includes("/auth/login") ||
          error.config.url.includes("/auth/reset-password") ||
          error.config.url.includes("/auth/refresh")
        )
      ) {
        const tokens = await authService.refreshToken();
        localStorage.setItem("accessToken", tokens.accessToken);
        localStorage.setItem("refreshToken", tokens.refreshToken);
        localStorage.setItem(
          "shopId",
          tokens.user?.shop_id || localStorage.getItem("shopId"),
        );
        error.config.headers.Authorization = `Bearer ${tokens.accessToken}`;

        const data = await axios(error.config);

        return data;
      } else if (error.response?.status === 401) {
        // the session ended: the shop's data leaves this device (queued sales stay)
        const { clearDeviceData } = await import("../services/offline/clearDeviceData");
        await clearDeviceData({ withSales: false });
      }

      throw error;
    } catch (e) {
      throw e;
    }
  },
);

export default axios;
